import { useEffect, useState } from 'react';
import ModalComponent from '../../../components/Modal/ModalComponent';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../components/card/card';
import { useTranslation } from 'react-i18next';
import Add from './Add';
import Update from './Update';
import { Link } from 'react-router-dom';
import Loading from '../../../components/Shared/Loader/Loading';
import i18n from '../../../i18n';
import NtxTable from '../../../components/DataTable/NtxTable';
import useGetBanks from '../../../hooks/Lookups/use-get-Banks';
  import { usePermissions } from '@Helper/Permisstions/usePermissions';
const Index = () => {
  const [item, setItem] = useState<any>();
  const [Show, setShow] = useState(false);
  const { t } = useTranslation();
  const { Banks, loading, error } = useGetBanks();
  const {HasPermission} = usePermissions()
  useEffect(() => {}, []);

  const columns = [
    { title: t('Name'), key: 'name' },
    { title: t('Code'), key: 'Code' },

    { title: '', key: 'action', className: 'text-end' },
  ];

  const tableData =
    Banks?.map((item: any) => {
      let rowClass;

      return {
        name: i18n.language === 'en' ? item.name : item.name2,
        Code: item.code,

        action: (
          <>
            {HasPermission('ViewDetailsHrPerBank') && (
              <button
                type="button"
                className="btn btn-sm btn-outline-theme ms-1"
                data-bs-toggle="modal"
                data-bs-target="#modalEdit"
                onClick={() => setItem(item)}>
                <i className="far fa-lg fa-fw fa-edit me-1"></i>
                {t('Button.Edit')}
              </button>
            )}
          </>
        ),
      };
    }) || [];

  //____________________________

  return (
    <div>
      <div className="d-flex align-items-center">
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome',
            },
            {
              name: 'Banks',
              link: null,
            },
          ]}
          PageName="Banks"
        />

        {HasPermission('AddHrPerBank') && (
          <div className="ms-auto">
            <Link
              to=""
              className="btn me-1 btn-theme"
              data-bs-toggle="modal"
              data-bs-target="#modalAdd"
              onClick={() => setShow(true)}>
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('NewBank')}
            </Link>
          </div>
        )}
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns || []}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch={true}
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddBank')} id="modalAdd" size="lg">
        {Show && <Add />}
      </ModalComponent>

      <ModalComponent title={t('EditBank')} id="modalEdit" size="lg">
        {item && <Update item={item} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
